import {
  Directive,
  EmbeddedViewRef,
  Inject,
  Input,
  Optional,
  Self,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';
import { environment } from 'environments/environment';

import { AuthorizeBase } from './authorize.base';
import { Authorizer, AUTHORIZERS } from './authorizer';

@Directive({
  selector: '[authorizeShow], [authorizeShowElse]',
  standalone: false,
})
export class AuthorizeShowDirective<TThen, TElse> extends AuthorizeBase {
  @Input() set authorizeShowElse(value: TemplateRef<TElse> | undefined) {
    this.elseTemplateRef = value;
  }

  private elseTemplateRef?: TemplateRef<TElse>;

  private thenViewRef?: EmbeddedViewRef<TThen>;
  private elseViewRef?: EmbeddedViewRef<TElse>;

  constructor(
    @Optional() @Self() @Inject(AUTHORIZERS) authorizers: Authorizer[],
    private viewContainer: ViewContainerRef,
    private thenTemplateRef: TemplateRef<TThen>,
  ) {
    super(authorizers);

    if (!authorizers?.length) {
      environment.warn(
        'Use <ng-template authorizeShow> not <div *authorizeShow> so that authorizers are bound correctly',
      );
    }
  }

  protected toggleAuthorized(isAuthorized: boolean) {
    if (isAuthorized) {
      if (this.elseViewRef) {
        this.viewContainer.clear();
        this.elseViewRef = undefined;
        this.thenViewRef = undefined;
      }
      if (!this.thenViewRef) {
        this.thenViewRef = this.viewContainer.createEmbeddedView(this.thenTemplateRef);
      }
    } else {
      if (this.thenViewRef) {
        this.viewContainer.clear();
        this.elseViewRef = undefined;
        this.thenViewRef = undefined;
      }
      if (!this.elseViewRef && this.elseTemplateRef) {
        this.elseViewRef = this.viewContainer.createEmbeddedView(this.elseTemplateRef);
      }
    }
  }
}
